import { create } from 'zustand';

// Define modal types
type ModalType = 'UPGRADE_SUBSCRIPTION' | 'SETTINGS' | 'FEEDBACK' | 'HELP';

interface ModalState {
  modalType: ModalType | null;
  isOpen: boolean;
  openModal: (type: ModalType) => void;
  closeModal: () => void;
}

// Create a store to manage modal state
const useModalStore = create<ModalState>((set) => ({
  modalType: null,
  isOpen: false,
  openModal: (type: ModalType) => set({ isOpen: true, modalType: type }),
  closeModal: () => set({ isOpen: false, modalType: null }),
}));

// Hook to use in components
export const useModal = () => {
  const { openModal, closeModal, isOpen, modalType } = useModalStore();
  
  return {
    openModal,
    closeModal,
    isOpen,
    modalType,
  };
}; 